// extracted by mini-css-extract-plugin
export var quote = "quote-block-module--quote--1493f";
export var wrapper = "quote-block-module--wrapper--8c06e";